// extracted by mini-css-extract-plugin
export default {"modalBody":"_51a27326","closeButton":"_ef75d21d"};